import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import ValueProposition from './components/ValueProposition';
import Services from './components/Services';
import GlobalPresence from './components/GlobalPresence';
import Contact from './components/Contact';
import ReferencesTestimonials from './components/ReferencesTestimonials';
import Footer from './components/Footer';

const NAVBAR_HEIGHT = 80;

const scrollToSection = (id: string) => {
  if (id === 'home') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }
  const element = document.getElementById(id);
  if (element) {
    const top = element.getBoundingClientRect().top + window.scrollY - NAVBAR_HEIGHT;
    window.scrollTo({ top, behavior: 'smooth' });
  }
};

const HomePage = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    (window as any).__bbScrollTo = scrollToSection;
    return () => { delete (window as any).__bbScrollTo; };
  }, []);

  return (
    <div className="overflow-x-hidden" style={{ backgroundColor: '#ffffff' }}>
      <Navbar scrolled={scrolled} />
      <div style={{ paddingTop: `${NAVBAR_HEIGHT}px` }}>
        <Hero />
        <About />
        <ValueProposition />
        <Services />
        <GlobalPresence />
        <Contact />
        <ReferencesTestimonials />
        <Footer />
      </div>
    </div>
  );
};

export default HomePage;
